import { useTranslation } from 'react-i18next'
import { SheetModal } from '../sheet-modal'
import { marketingService } from '../../../../core/services'
import { useWindowActions } from '../../../../models/window'
import { copyToClipboard } from '../../../../core/helpers/copy-to-clipboard'
import { getPromoUrl, PromoUrlType } from '../../../../core/helpers/promo-url'
import { useAutoTranslate } from '../../../../core/hooks/useAutoTranslate'

import c from './promo-code-modal.module.scss'

const PromoCodeModal = ({ promo }) => {
    const { t } = useTranslation()
    const { closeWindow } = useWindowActions()
    
    // Автоперевод динамического контента
    const translatedTitle = useAutoTranslate(promo?.title)
    const translatedDescription = useAutoTranslate(promo?.description)
    const translatedHint1 = useAutoTranslate(promo?.hint1)
    const translatedHint2 = useAutoTranslate(promo?.hint2)
    const translatedButtonText = useAutoTranslate(promo?.buttonText)
    
    const handleButtonClick = () => {
        if (promo?.notificationId) {
            marketingService.markClicked(promo.notificationId).catch(() => {})
        }
        
        // Если есть promoCode в данных, генерируем правильную ссылку
        let url
        if (promo?.promoCode) {
            // Определяем тип по prizeType из маркетинговой кампании
            const promoType =
                promo?.prizeType === 'PROMO_DEPOSIT' ||
                promo?.prizeType === 'DEPOSIT_FREE_CASE'
                ? PromoUrlType.DEPOSIT
                : promo?.prizeType === 'PROMO_WHEEL'
                ? PromoUrlType.WHEEL
                : PromoUrlType.BONUS
            
            url = getPromoUrl(promo.promoCode, promoType)
        } else {
            // Используем переданный URL или дефолтный
            url = promo?.buttonUrl || 'https://ggstand.live/m/ggturbo'
        }
        
        console.log('🔗 Marketing promo URL:', url)
        
        try {
            if (window?.Telegram?.WebApp?.openLink) {
                window.Telegram.WebApp.openLink(url)
            } else {
                window.open(url, '_blank')
            }
        } catch (e) {
            console.error('Error opening link:', e)
            window.open(url, '_blank')
        }
        
        closeWindow()
    }

    return (
        <SheetModal>
        <div className={c.component}>
            <div className={c.header}>
                    <img
                        src={promo?.imageUrl || '/images/bonus.png'}
                        alt="poster"
                    />
            </div>
            <div className={c.main}>
                    <p className={c.title}>
                        {translatedTitle || t('modal.promoCode.title')}
                    </p>
                    <p className={c.subtitle}>
                        {translatedDescription || t('modal.promoCode.subtitle')}
                    </p>
                {promo?.promoCode && (
                    <div className={c.code}>
                        <div className={c.codeRow}>
                                <span className={c.codeText}>
                                    {promo.promoCode}
                                </span>
                                <span className={c.codeTitle}>
                                    {t('modal.promoCode.code')}
                                </span>
                        </div>
                        <button
                            type="button"
                            className={c.codeButton}
                                onClick={() =>
                                    copyToClipboard(
                                        promo.promoCode,
                                        t('common.copy.success')
                                    )
                                }
                        >
                                <span>{t('modal.promoCode.copy')}</span>
                        </button>
                    </div>
                )}
                <div className={c.list}>
                        {promo?.hint1 && (
                            <p className={c.item}>{translatedHint1}</p>
                        )}
                        {promo?.hint2 && (
                            <p className={c.item}>{translatedHint2}</p>
                        )}
                    {!promo?.hint1 && !promo?.hint2 && (
                        <>
                                <p className={c.item}>
                                    {t('modal.promoCode.hint1')}
                                </p>
                                <p className={c.item}>
                                    {t('modal.promoCode.hint2')}
                                </p>
                        </>
                    )}
                </div>
            </div>
            <div className={c.bottom}>
                    <button
                        type="button"
                        className={c.btn}
                        onClick={handleButtonClick}
                    >
                        <span>
                            {translatedButtonText || t('modal.promoCode.button')}
                        </span>
                </button>
            </div>
        </div>
    </SheetModal>
    )
}

export default PromoCodeModal
